export default {
  VehicleDocument: "VehicleDocument",
  AddVehicleDocument: "AddVehicleDocument",
  editVehicleDocument: "EditVehicleDocument",
};
